<app-dialog-header [title]="data.modalTitle" />
<mat-dialog-content class="confirm-action-modal__content">
  <div class="confirm-action-modal__shell">
    <p class="confirm-action-modal__message" [innerHTML]="data.modalContent"></p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="confirm-action-modal__actions">
  @if (data.cancelMessage) {
    <app-button styleType="outlined" (btnClick)="dialogRef.close()">
      {{ data.cancelMessage }}
    </app-button>
  }
  <app-button (btnClick)="dialogRef.close(true)">{{ data.confirmMessage }}</app-button>
</mat-dialog-actions>
